import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="tags"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.initializeTomSelect()
    // Add listener for dark mode changes
    this.darkModeObserver = new MutationObserver(() => this.updateDarkMode())
    this.darkModeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  initializeTomSelect() {
    const isInline = this.element.dataset.tagsStyle === "inline"
    const isDark = document.documentElement.classList.contains('dark')
    
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }

    this.tomSelect = new TomSelect(this.selectTarget, {
      plugins: ['remove_button'],
      persist: false,
      createOnBlur: true,
      create: true,
      maxItems: null,
      valueField: 'value',
      labelField: 'value',
      searchField: 'value',
      options: this.selectTarget.options,
      items: Array.from(this.selectTarget.selectedOptions).map(option => option.value),
      render: {
        option: function(data, escape) {
          return `<div class="py-1 px-2">
            <span>${escape(data.value)}</span>
          </div>`
        },
        item: function(data, escape) {
          return `<div class="inline-flex items-center bg-blue-100 text-blue-800 text-xs font-medium mr-1 px-1.5 rounded dark:bg-blue-900 dark:text-blue-300">
            ${escape(data.value)}
          </div>`
        },
        no_results: function(data, escape) {
          return `<div class="py-1 px-2">No results found for "${escape(data.input)}"</div>`;
        }
      },
      dropdownParent: 'body',
      controlClass: isInline ? 'ts-inline-control' : 'ts-control',
      dropdownClass: `ts-dropdown ${isDark ? 'dark-dropdown' : ''}`,
      dropdownContentClass: isInline ? 'ts-dropdown-content ts-inline-dropdown' : 'ts-dropdown-content',
      classNames: {
        dropdown: isDark ? 'bg-gray-800 border-gray-600' : '',
        option: isDark ? 'text-white hover:bg-gray-700' : '',
        item: isDark ? 'bg-gray-700 text-white' : '',
      }
    })

    if (isInline) {
      this.tomSelect.wrapper.classList.add('ts-inline-wrapper')
    }
    if (isDark) {
      this.tomSelect.wrapper.classList.add('ts-dark')
    }
  }

  updateDarkMode() {
    if (this.tomSelect) {
      const isDark = document.documentElement.classList.contains('dark')
      this.tomSelect.wrapper.classList.toggle('ts-dark', isDark)
      // Reinitialize to update dropdown styles
      this.initializeTomSelect()
    }
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
    if (this.darkModeObserver) {
      this.darkModeObserver.disconnect()
    }
  }
} 